// @ts-check

import '../jsdoc-types';
import {Alert, Button, EmailField, RadioGroup, TextField} from '@bonprix/design-system';
import {TrinityEvents} from '@service/scripts/trinity.js';
import {useSubscriptionForm} from './useSubscriptionForm.js';
import React from "react";

export function NewsletterSubscriptionForm(/** @type {{cdaEntry: NewsletterSubscriptionFormEntry, friendlyCaptchaEnabled: boolean, friendlyCaptchaSitekeyNewsletter: string, friendlyCaptchaSitekeyNewsletterAt: string, tenantCountry: string, postValues: any}} */ {
                                               cdaEntry,
                                               friendlyCaptchaEnabled,
                                               friendlyCaptchaSitekeyNewsletter,
                                               friendlyCaptchaSitekeyNewsletterAt,
                                               tenantCountry,
                                               postValues
                                           }) {
    const friendlyCaptchaSitekey = tenantCountry === 'at' ? friendlyCaptchaSitekeyNewsletterAt : friendlyCaptchaSitekeyNewsletter;
    const fieldVisibility = {
        salutation: cdaEntry.showSalutation !== false,
        firstName: cdaEntry.showFirstName !== false,
        lastName: cdaEntry.showLastName !== false,
    };

    const {formValues, submitButtonIsDisabled, isSubmitting, errorMsg, formErrors, fcContainer, handleChange, handleSubmit} = useSubscriptionForm({
        cdaEntry,
        postValues,
        friendlyCaptchaEnabled,
        fieldVisibility,
        onTrack: () => TrinityEvents.sendClickNewsletter('sendNewsletterSubscription', 'button'),
    });

    return (
        <div className="service-page-newsletter-subscription-form">
            <form onSubmit={handleSubmit}>
                <div className="form-row">
                    <EmailField
                        label={cdaEntry.labelEmail}
                        required
                        inputMode="email"
                        value={formValues.email}
                        name="email"
                        onChange={handleChange('email')}
                        error={formErrors && !!formErrors.email}
                        errorText={formErrors && formErrors.email && cdaEntry.errorEmail}
                    />
                </div>

                {fieldVisibility.salutation && <div className="form-row form-salutation-group">
                    <RadioGroup
                        label={cdaEntry.labelSalutation}
                        required
                        value={formValues.salutation}
                        name="salutation"
                        onChange={handleChange('salutation')}
                        error={formErrors && !!formErrors.salutation}
                        errorText={formErrors && formErrors.salutation && cdaEntry.errorSalutation}
                    >
                        <RadioGroup.Item value="0" label={cdaEntry.labelSalutation0} />
                        <RadioGroup.Item value="1" label={cdaEntry.labelSalutation1} />
                        <RadioGroup.Item value="2" label={cdaEntry.labelSalutation2} />
                        <RadioGroup.Item value="3" label={cdaEntry.labelSalutation3} />
                    </RadioGroup>
                </div>}

                {fieldVisibility.firstName && <div className="form-row">
                    <TextField
                        label={cdaEntry.labelFirstName}
                        required
                        name="firstName"
                        value={formValues.firstName}
                        onChange={handleChange('firstName')}
                        error={formErrors && !!formErrors.firstName}
                        errorText={formErrors && formErrors.firstName && cdaEntry.errorFirstName}
                    />
                </div>}

                {fieldVisibility.lastName && <div className="form-row">
                    <TextField
                        label={cdaEntry.labelLastName}
                        required
                        name="lastName"
                        value={formValues.lastName}
                        onChange={handleChange('lastName')}
                        error={formErrors && !!formErrors.lastName}
                        errorText={formErrors && formErrors.lastName && cdaEntry.errorLastName}
                    />
                </div>}

                {friendlyCaptchaEnabled && (
                    <div className="form-row">
                        <div ref={fcContainer} className="frc-captcha" data-sitekey={friendlyCaptchaSitekey} data-lang="de"></div>
                        {formErrors && formErrors["frc-captcha-solution"] && (
                            <Alert isOpen status="error" showCloseIcon={false}>{cdaEntry.errorFriendlyCaptcha}</Alert>
                        )}
                    </div>
                )}

                {errorMsg && (
                    <div className="form-row">
                        <Alert isOpen status="error" showCloseIcon={false}>{errorMsg}</Alert>
                    </div>
                )}

                <div className="form-row">
                    <Button type="submit" disabled={submitButtonIsDisabled} loading={isSubmitting}>
                        {cdaEntry.labelButtonSubmit}
                    </Button>
                </div>
            </form>
        </div>
    );
}
